import SmartFeedEngine from "@/smart-feed/smart-feed-engine";
import { defineSmartFeedPiniaStore } from "@bloglovin/vue-framework";

export const useCommunityNetworkFeedStore = defineSmartFeedPiniaStore(
  "community-network-feed-store",
  {
    state: () => ({
      smartFeedEngine: new SmartFeedEngine(),
      defaultFilterValues: {
        networkName: {
          key: "network_name",
          payload: "",
        },
      },
      tableFields: [{ key: "name", label: "Name" }],
    }),
    getters: {
      feedUrl() {
        return "/network/community";
      },
    },
  },
);
